// extracted by mini-css-extract-plugin
export default {"wrapper":"Special_wrapper__w-qAW","title":"Special_title__oMc0x","cards":"Special_cards__JDiE9"};